import { Component } from '@angular/core';
import { DomainDefinitionService } from '../../../../../services/domain-definition.service';
import { LunaDomain } from '../../../../../models/domain.model';
import { BaseControlComponent } from '../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';


@Component({
    selector: 'app-multiselect-display-config',
    templateUrl: './multiselect-display-config.component.html',
    standalone: false
})
export class MultiselectDisplayConfigComponent extends BaseControlComponent {
    static componentName = 'MultiselectDisplayConfigComponent';

    public isLoading: boolean = false;
    public domains: Array<LunaDomain> = new Array<LunaDomain>();

    constructor(public _domainService: DomainDefinitionService, public readonly contextService: ContextInteractionService) {
        super(contextService);

        //this value will be cached.
        this._domainService.getAll().subscribe(x => this.domains = x);
    }

    public getDomainValues(): Array<string> {
        let domain = this.domains.find(x => x.id === this.componentData.config.domain);
        if (!domain)
            return;

        return domain.values;
    }
}